<template>
  <footer class="app-footer">
    <a href="https://zeekdoc.com">Zeekdoc</a> &copy; 2017 Zeekdoc Co., Ltd,
    
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?1454ab5e